module.exports = __webpack_public_path__ + "static/img/peachmangobublyburst_th.b9ce866.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/peachmangobublyburst_th.png
// module id = O0kw
// module chunks = 0